import { usePrivy } from '@privy-io/react-auth'
import type { User } from '@privy-io/react-auth'
import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'

/**
 * Hook that identifies the user in PostHog when they log in
 */
export const useTrackUser = () => {
  const { user } = usePrivy()
  const postHog = usePostHog()

  useEffect(() => {
    if (user) {
      identifyUser(user, postHog)
    } else {
      // Reset identification if user logs out
      postHog.reset()
    }
  }, [user, postHog])
}

/**
 * Identifies a user in PostHog with their ID and properties
 */
export const identifyUser = (user: User, postHog: any) => {
  if (!user) return

  // Collect wallet addresses from linked accounts
  const walletAddresses = user.linkedAccounts
    .filter((account) => account.type === 'wallet')
    .map((wallet) => wallet.address)

  // Get primary wallet if available
  const primaryWallet = walletAddresses.length > 0 ? walletAddresses[0] : undefined

  // Identify user with ID and properties
  postHog.identify(user.id, {
    userId: user.id,
    email: user.email?.address,
    walletAddresses,
    primaryWallet,
    hasEmbeddedWallet: !!user.wallet,
  })
}
